import React from "react";
import { Link } from "react-router-dom";

export default function RedirectFooter({ to, redirect = null }) {
  return (
    <p className="text-white w-full flex font-semibold mt-1 font-sans">
      {to === "signup" ? (
        <span>
          Don't have an account?{" "}
          {redirect ? (
            <Link className="text-blue-100" to={`/signup?redirect=${redirect}`}>
              Sign Up
            </Link>
          ) : (
            <Link className="text-blue-100" to="/signup">
              Sign Up
            </Link>
          )}
        </span>
      ) : (
        <span>
          Are you already have account?{" "}
          {redirect ? (
            <Link className="text-blue-100" to={`/login?redirect=${redirect}`}>
              Login
            </Link>
          ) : (
            <Link className="text-blue-100" to="/login">
              Login
            </Link>
          )}
        </span>
      )}
    </p>
  );
}
